module.exports = __webpack_public_path__ + "img/kilometer.5bcad3ae.svg";